import { render, staticRenderFns } from "./ProgressBarColor.html?vue&type=template&id=5ddd0f1a&scoped=true&"
import script from "./ProgressBarColor.ts?vue&type=script&lang=ts&"
export * from "./ProgressBarColor.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/progress-bar-color/_progress-bar-color.scss?vue&type=style&index=0&id=5ddd0f1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddd0f1a",
  null
  
)

export default component.exports